import { useDispatch } from 'react-redux'

import { TableList, TableColumns } from 'components/common'
import HallApi, { getDetailUrl, pkField } from 'models/Hall/api'
import { HallActions } from 'models/Hall/slice'
import { BuildingPlaceValue } from 'models/BuildingPlace/components'
import HallValue from '../HallValue'


const defaultColumnList = ['name', 'place', 'sort', 'isActive', 'actions'];


const HallList = ({ columnList, params, filterParams, onEdit }) => {
  const [apiGetList, apiGetListProps] = HallApi.endpoints.getHallList.useLazyQuery();
  const [apiUpdate, apiUpdateProps] = HallApi.endpoints.updateHall.useMutation();
  const [apiDelete, apiDeleteProps] = HallApi.endpoints.deleteHall.useMutation();
  const [apiBatchDelete, apiBatchDeleteProps] = HallApi.endpoints.batchDeleteHall.useMutation();

  const dispatch = useDispatch();

  const fields = {
    name: {
      title: 'Название',
      sorter: true,
      render: (val, item) => (<HallValue detail={item} asLink={true} isBack={true} />),
    },
    place: {
      title: 'Помещение',
      width: 150,
      render: (val, item) => (<BuildingPlaceValue detail={val} asLink={true} isBack={true} />),
    },
    sort: { title: 'Сортировка', sorter: true, width: 130 },
    isActive: TableColumns.getColumnOnOff({ title: 'Активно', fieldName: 'isActive', apiUpdate, apiUpdateProps }),

    actions: TableColumns.getColumnActions({
      getDetailUrl,
      getActions: (item) => [
        { name: 'edit', action: () => dispatch(HallActions.openForm({ name: 'editForm', pk: item[pkField] })) },
        { name: 'delete', action: () => apiDelete(item[pkField]) },
      ]
    }),
  };

  return (
    <TableList
      queryKey="hall"
      rowKey={pkField}
      params={params}
      filterParams={filterParams}
      fields={fields}
      columnList={columnList || defaultColumnList}

      apiGetList={apiGetList}
      apiGetListProps={apiGetListProps}
      apiUpdateProps={apiUpdateProps}
      apiDeleteProps={apiDeleteProps}
      apiBatchDelete={apiBatchDelete}
      apiBatchDeleteProps={apiBatchDeleteProps}
      onEdit={onEdit}

      rowSelection={false}
      hidePagination={false}
      hideStat={false}
    />
  );
}

export default HallList;
